export const NAVIGATION_STALE_THRESHOLD = 24 * 60 * 60 * 1000;

export interface NavigationStateData {
  data: Record<string, unknown>;
  timestamp: number;
}

export interface NavigationStateStore {
  [key: string]: NavigationStateData;
}
